import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#018786', // verde
    },
    background: {
      default: '#fafafa00',
    },
  },
  // overrides: {
  //   MuiCssBaseline: {
  //     '@global': {
  //       body: {
  //         backgroundImage:
  //           'url(https://designshack.net/wp-content/uploads/gradient-background.jpg)'
  //       }
  //     }
  //   }
  // }
})

export default theme

// check: https://material-ui.com/es/customization/default-theme/
